const DEFAULT_API_URL = '/api'

export const API_USER = {
  BASE_API_URL: `${DEFAULT_API_URL}/user/`,
  LOGOUT: 'logout.php',
  AUTH: 'auth.php',
  NOTIFICATIONS: 'notifications.php',
  FORGET_PASSWORD: 'forget_password.php',
  PASSWORD: 'password.php',
  UPDATE_SETTINGS: 'update_settings.php',
  UPDATE_PASSWORD: 'update_password.php',
  GATEWAY_CHECK: 'gateway_check.php',
  MODULES: 'modules.php',
  MENUS: 'nav_modules.php',
}

export const API_AUTH = Object.freeze({
  SESSION_REFRESH: `/auth/session/refresh`,
  CHANGE_PASSWORD: '/auth/change-password',
})

export const API_LPE = {
  BASE_API_URL: `${DEFAULT_API_URL}/lpe/`,
  LOCATIONS: 'location.php',
  LOCATION: 'location_id_localized.php',
  LOCATION_EXPORT: 'location_export.php',
  EOH_EXPORT: 'eoh_export.php',
  URL_EXPORT: 'location_urls_export.php',
  LOCATION_OPENING_HOUR: 'location-opening-hours_id.php',
  LOCATION_EXCEPTIONAL_OPENING_HOURS: 'location-exceptional-opening-hours.php',
  LOCATION_EXCEPTIONAL_OPENING_HOUR: 'location-exceptional-opening-hours_id.php',
  LOCATION_URLS: 'location-url.php',
  LOCATION_URL: 'location-url_id.php',
  FRONT_OFFICE: 'front-office_id_localized.php',
  FRONT_OFFICE_SEO_CHAR_COUNTER: 'front-office-seo-char-counter.php',
  GMB_LOCATION_WITHOUT_ASSOCATION: 'gmb_locations_without_assocation.php',
  GMB_LOCATION_ID_MAPPING: 'gmb_location_id_mapping.php',
  CLIENTS: 'client.php',
  CLIENT: 'client_id_localized.php',
  LOCATION_GROUPS: 'location_groups.php',
  USER_EXPRESS: 'user-express.php',
  USER_EXPRESS_ID: 'user-express_id.php',
  USER_EXPRESS_CAMPAIGN: 'user-express-campaign.php',
  USER_EXPRESS_CAMPAIGN_ID: 'user-express-campaign-id.php',
  USER_EXPRESS_CAMPAIGN_SUBMIT: 'user-express-campaign_submit.php',
  USER_EXPRESS_CAMPAIGN_HISTORY: 'user-express-campaign-history.php',
  USER_EXPRESS_CAMPAIGN_HISTORY_FULL: 'user-express-campaign-history-full.php',
  OH_GROUP: 'opening-hours-groups.php',
  OH_GROUP_ID: 'opening-hours-group_id.php',
  OH_GROUP_SUBGROUP: 'opening-hours-subgroups.php',
  OH_GROUP_SUBGROUP_ID: 'opening-hours-subgroup_id.php',
  OH_GROUP_COUNTRIES: 'locations-countries.php',
  LOCATION_OPENING_HOURS: 'location-opening-hours.php',
  TMP_LOCATION_OPENING_HOURS: 'tmp-location-opening-hours.php',
  TMP_LOCATION_EXCEPTIONAL_OPENING_HOURS: 'tmp-location-exceptional-opening-hours.php',
  NETLIFY_GEO_IP: '/.netlify/functions/geoip',
}

export const API_TOOLS = {
  BASE_API_URL: `${DEFAULT_API_URL}/tools/`,
  UPLOAD_MEDIA: 'upload_media.php',
  CLONE_MEDIA: 'clone_media.php',
  REMOVE_MEDIA: 'remove_media.php',
  GEOCODE: 'geocode.php',
  INTERNATIONAL_PHONE: 'international_phone.php',
  COUNTRIES: 'countries.php',
}

export const API_KPIS = {
  BASE_API_URL: `${DEFAULT_API_URL}/kpis/`,
  LIST: 'list.php',
  LPE_AVERAGE_POSITION: 'lpe-average-position.php',
  LPE_TOP_KEYWORDS_BY_CITY: 'lpe-top-keywords-by-city.php',
  LPE_TOP_PRINTS_BY_CITY: 'lpe-top-prints-by-city.php',
  LPE_LOCAL_PAGE_AUDIENCE: 'lpe-local-page-audience.php',
}

export const API_RADAR = {
  BASE_API_URL: `${DEFAULT_API_URL}/radar/`,
  APP: 'app.php',
}

export const API_ALGOLIA = {
  BASE_API_URL: `${DEFAULT_API_URL}/algolia/`,
  FRONT_OFFICE_INDICE: 'front-office_id_indice.php',
  LAUNCH_SYNCHRO: 'launch_synchro.php',
  SETTINGS: 'settings.php',
}

export const API_GMB = {
  BASE_API_URL: `${DEFAULT_API_URL}/gmb/`,
  HOLIDAYS: '/publicholidays?',
  CATEGORIES: 'categories.php',
  ATTRIBUTES: 'attributes.php',
  CHAINS: 'search_chains.php',
  ACCOUNTS: 'accounts.php',
  ACCOUNTS_FULL: 'accounts_full.php',
  ACCOUNT: 'account_id.php',
  ACCOUNT_NOTIFICATION: 'account_id_notification.php',
  LOCATION_GOOGLE_UPDATES: 'locations_update.php',
  LOCATIONS: 'locations.php',
  LOCATION: 'location_id.php',
  LOCATION2: 'location_id2.php',
  LOCATION_MAPPING: 'location_id_mapping.php',
  LOCAL_POSTS: 'local_posts.php',
  MEDIA: 'location_id_media.php',
  MEDIA_ID: 'location_id_media_id.php',
  QUESTIONS_ANSWERS: 'questions_answers.php',
  QUESTIONS_ANSWERS_ID: 'questions_answers_id.php',
  QUESTIONS_ANSWERS_ID_ANSWER_ID: 'questions_answers_id_answer_id.php',
  UPDATE_HISTORY: 'update_history.php',
  UPDATE_ATTRIBUTE_HISTORY: 'update_attribute_history.php',
  MEDIA_CUSTOMER: 'media_customer_id_takedown.php',
  INVITATIONS: 'invitations.php',
  SERVICES: 'location_services.php',
}

export const API_PM = {
  BASE_API_URL: `${DEFAULT_API_URL}/pm/`,
  PRESENCE_MANAGEMENT: 'presence-management.php',
  INDIVIDUAL_HISTORY: 'location-history.php',
}

export const GTR_CORE = {
  BASE_API_URL: `/gtr-core/`,
  AUTH: 'auth',
  LPE_CLIENT: 'lpe/client',
  LPE_LOCATION: 'lpe/location',
  FEATURE_LIST: 'lpe/feature-list',
  LPE_PRIVATE_FRONT_OFFICE: 'lpe/private/front-office',
  LPE_FRONT_OFFICE_LIST: 'lpe/front-office/list',
  LPE_LOCALE: 'lpe/locale',
}

export const API_GEONAMES = {
  BASE_API_URL: '/geonames-io/',
  API: 'api',
  BEARER_TOKEN: 'Bearer k4RIoiKxbovJh4sV7n5JqMTcC7aczBe5',
  ADMINISTRATIVE_DIVISIONS: 'administrativedivisions',
  GEONAMES: 'geonames',
  SEARCH: 'search',
}
